/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_Updating_DescriptionInputs */

const en_app_updating_description = /** @type {(inputs: App_Updating_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A new version is available. This should only take a moment.`)
};

const pt_br2_app_updating_description = /** @type {(inputs: App_Updating_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma nova versão está disponível. Isso deve levar apenas um momento.`)
};

/**
* | output |
* | --- |
* | "A new version is available. This should only take a moment." |
*
* @param {App_Updating_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const app_updating_description = /** @type {((inputs?: App_Updating_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_Updating_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_app_updating_description(inputs)
	return pt_br2_app_updating_description(inputs)
});